import React, { useState } from 'react';
import Button from '../../atoms/Button';
import Icon, { IconName } from '../../atoms/Icon';
import { SizeName } from '../../../types/buttonStyle';
import { useTheme } from 'styled-components';
import { Wrapper, IconWrapper, ButtonWithIconText, Badge } from './styled';

interface ButtonWithIconProps {
  /**
   * Size of the Button
   */
  size: SizeName;
  /**
   * Text content of the button
   */
  children?: React.ReactNode;
  /**
   * Disable status of button
   */
  disabled?: boolean;
  /**
   * Variant type of the button
   */
  variant: 'primary' | 'outline' | 'subtle' | 'link';
  /**
   *  when block mode is true, the button will occupy the whole width of the div parent
   */
  block?: boolean;
  /**
   *  onClick handler
   */
  onClick?: ((e?: MouseEvent) => void) | ((e?: MouseEvent) => Promise<void>);
  /**
   *  set the button type
   */
  type?: 'button' | 'submit' | 'reset' | undefined;
  /**
   *  set Icon type
   */
  iconName: IconName;
  /**
   *  set the icons placement to right
   */
  rightIcon?: boolean;

  /*Sets a badge with the number inside*/
  badge?: number;
}

/**
 *  Button Component with selactable icon on name props,
 *
 */
const ButtonWithIcon = (props: ButtonWithIconProps) => {
  const {
    type = 'button',
    onClick,
    size,
    disabled,
    children,
    variant,
    block,
    iconName,
    rightIcon,
    ...rest
  } = props;

  const [isHovered, setIsHovered] = useState<boolean>(false);

  //access theme outside of styled components
  const theme = useTheme();

  //get the size of the icon according to Button Size
  const getIconSize = (): number => {
    if (size === 'xs' || size === 'sm') {
      return 16;
    }
    return 24;
  };

  //get the IconColor depending on variant
  const getIconColor = (): any => {
    if (variant === 'primary') {
      return theme.colors.text.white;
    }
    if (variant === 'outline') {
      if (isHovered) {
        return theme.colors.text.primary;
      }
      return theme.colors.text.default;
    }
    if (variant === 'link') {
      return theme.colors.text.primary;
    }
    if (variant === 'subtle') {
      return theme.colors.text.default;
    }
  };

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ display: 'inline' }}
    >
      <Button
        type={type}
        onClick={onClick}
        size={size}
        variant={variant}
        disabled={disabled}
        block={block}
        {...rest}
      >
        <Wrapper rightIcon={rightIcon} noText={props.children === undefined}>
          <IconWrapper>
            <Icon name={iconName} size={getIconSize()} color={getIconColor()} />
          </IconWrapper>
          <ButtonWithIconText size={size}>{children}</ButtonWithIconText>
        </Wrapper>
      </Button>
      {props.badge ? <Badge>{props.badge}</Badge> : null}
    </div>
  );
};

export default ButtonWithIcon;
